import React from 'react';
import Modal from 'components/UI/Modal';
import { Main } from 'styles/themeColors';
import { GENERAL_CONSTANTS } from 'constants/general';

interface ConfirmationModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    color?: string;
    primaryButtonColor?: string;
    borderColor?: string;
    disabled?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    show,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = GENERAL_CONSTANTS.CONFIRM,
    cancelText = GENERAL_CONSTANTS.CANCEL,
    color = Main.black,
    primaryButtonColor = Main.brandDark,
    borderColor = Main.disabled,
    disabled = false,
}) => (
    <Modal
        showModal={show}
        onClose={onClose}
        onClick={onConfirm}
        title={title}
        primaryButtonText={confirmText}
        ghostButtonText={cancelText}
        primaryButtonColor={primaryButtonColor}
        color={color}
        borderColor={borderColor}
        disabled={disabled}
    >
        <p>{message}</p>
    </Modal>
);

export default React.memo(ConfirmationModal);